export default {
  links: [
    { title: "Home", text: "Home" },
    { title: "Movies", text: "Movies" },
    { title: "Releases", text: "Releases" },
    { title: "Marvel", text: "Marvel" },    //
    { title: "AboutMe", text: "About" }
  ]
};
